<ng-container *ngIf="profileField$ | async as profileField">
    <ng-container *ngIf="childDefinition$ | async as childFieldDefinition">
        <ng-container [ngSwitch]="childFieldDefinition?.Type">
            <ng-container *ngSwitchCase="FieldType.ThesaurusField">
                <ng-container *ngTemplateOutlet="thesaurusList; context: { profileField, childFieldDefinition }"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="FieldType.PositionField">
                <ng-container
                    *ngTemplateOutlet="addressList; context: { profileField, padding: nestedPadding$ | async, nestedIndex: nestedIndex$ | async }"
                ></ng-container>
            </ng-container>

            <ng-container *ngSwitchDefault>
                <ng-container *ngTemplateOutlet="defaultComplexList"></ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #emptyData>
    <dd class="sh-description-list__details">-</dd>
</ng-template>

<ng-template #thesaurusList let-profileField="profileField" let-childFieldDefinition="childFieldDefinition">
    <dt [id]="profileField.FieldDefinition.FlatKey" class="sh-description-list__term">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="$labelIcons()"></sh-field-label>
    </dt>
    @if (suggestions$ | async; as suggestions) {
        @if (listValues) {
            <dd class="sh-description-list__details" *ngIf="listValues.length > 0 || suggestions.length > 0; else emptyData">
                <span *ngFor="let value of listValues; let index = index">
                    <med-thesaurus-concept [conceptReference]="value" [thesaurusFieldDefinition]="childFieldDefinition"></med-thesaurus-concept>
                    <ng-container *ngIf="index < listValues.length - 1">, </ng-container>
                </span>

                @if (listValues.length > 0 && suggestions.length > 0) {
                    <span>, </span>
                }

                @for (suggestion of suggestions; track suggestion; let idx = $index) {
                    <i class="sh-icon-label" style="margin-left: 0">
                        <span>{{ suggestion }}</span>
                        <span class="sh-icon-label__icon -sh-superscript" style="margin-left: 2px" [title]="'thesaurus.suggestion-not-approved' | translate">
                            <svg sh-icon [size]="'small'" aria-hidden="true" [name]="'info'"></svg>
                        </span>
                    </i>

                    @if (idx < suggestions.length - 1) {
                        <span>, </span>
                    }
                }
            </dd>
        }
    }
</ng-template>

<ng-template #addressList let-profileField="profileField" let-padding="padding" let-nestedIndex="nestedIndex">
    <ng-container *ngIf="flattenedComplexListFieldRecords">
        <ng-container>
            <ng-container *ngFor="let recordValue of flattenedComplexListFieldRecords; let index = index">
                <ng-container *ngIf="childProfileField$ | async as child">
                    <med-address-readonly-field
                        [record]="recordValue"
                        [profileField]="child"
                        [index]="index"
                        [nestedIndex]="nestedIndex$ | async"
                    ></med-address-readonly-field>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #defaultComplexList>
    <sh-complex-list-readonly-field [profileField]="profileField$ | async" [record]="record$ | async"></sh-complex-list-readonly-field>
</ng-template>

<ng-template #emptyData>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
